import React, { useState, useEffect } from 'react';
// material-ui
import { Box, FormControl, MenuItem, InputLabel, Select } from '@mui/material/';
import Auditor from '../../dataObjects/Auditor';

interface Props {
    auditorId: number;
    auditors: Auditor[];
    updateAuditorId: (auditorId: number) => void;
}

const AuditorsDropdown = (props: Props) => {

    const updateAuditorId = (event: any) => {
        let auditorId = event.target.value;
        props.updateAuditorId(auditorId);
    }

    return (
        <Box>
            <FormControl sx={{ m: 1, minWidth: 120, maxWidth:150}} size="small">
                <InputLabel>Auditor</InputLabel>
                <Select
                    value={props.auditorId}
                    label="Auditor"
                    sx={{ fontSize: 14 }}
                    onChange={updateAuditorId}
                >{
                        props.auditors.map(auditor =>
                            <MenuItem key={auditor.employeeId} value={auditor.employeeId}>{auditor.name}</MenuItem>
                        )
                    }
                </Select>
            </FormControl>
         </Box>
        
    )
}

export default React.memo(AuditorsDropdown);